import  {AfterViewInit, Component, ElementRef, Input, NgZone, OnInit, ViewChild} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {
  addTravelApi,
  assignTirpToBus,
  assignToBusApi, createTirpDetails,
  editTravelApi,
  getAssignTirpToBus,
  getTravelApi,
  getTravelsApi,
  removeTravelApi
} from '../api/tripline';
import {getBusesApi} from '../api/bus';
import swal from "sweetalert2";
import { MapsAPILoader, MouseEvent } from '@agm/core';
import { } from 'googlemaps';


declare var google;
declare var L;
@Component({
  selector: 'app-trip-line',
  templateUrl: './trip-line.component.html',
  styleUrls: ['./trip-line.component.css']
})
export class TripLineComponent implements OnInit,AfterViewInit {
  ngAfterViewInit(): void {

    console.log('updated')

    }
   editMode = false;
   travels = [];
  backTravels = [];
   rowSelected = {};
  tableView = false;
  zoom: number = 8;
  pointIndex=-1
  loader=true
  public searchControl: FormControl;

  @ViewChild("search")
  public searchElementRef: ElementRef;
  // initial center position for the map
  lat: number =31.963158;
  lng: number = 35.930359;
  constructor(private _fb: FormBuilder,    private mapsAPILoader: MapsAPILoader,private ngZone: NgZone) {
  }

  data: FormGroup;

  map: any;
  private geoCoder;

  // @ViewChild('map') mapElement: ElementRef;
  // @ViewChild('inputElement') inputElement: ElementRef;
  @Input('showInput')showInput=false
  markerLayer = new L.LayerGroup();
  polyLineLayer = new L.LayerGroup();
  ngOnInit() {
    this.searchControl = new FormControl();




    // var OsloToBerlin = Distance.between(Oslo, Berlin);

    // console.log(dist.getDistance("52.523", "13.412", "59.914", "10.752"))
    this.data = this._fb.group({
      travel_start_name: ['', Validators.required],
      travel_end_name: ['', Validators.required],
      way: ['', Validators.required],
      way_points: this._fb.array([], Validators.min(1)),
      work_days: this.initDaysItemRows() ,
    });
    this.getTravels();
    this.getBuses();
    this.setCurrentPosition()
    // this.generateMap()

    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ["address"]
      });
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.lat = place.geometry.location.lat();
          this.lng = place.geometry.location.lng();
          this.zoom = 12;
        });
      });
    });


  }

  searchPlace(place){

  }
  private setCurrentPosition() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
        this.zoom = 12;
      });
    }
  }
  deleteWayPoint(index: number) {
    const control = <FormArray>this.data.controls['way_points'];
    control.removeAt(index);
  }
  addWayPoint() {
    const control = <FormArray>this.data.controls['way_points'];

    control.insert(0,this.initItemRows());

  }

  initItemRows(label= '', lat= 0, lng= 0, time= '') {


    return this._fb.group({
      label: [label, Validators.required],
      lat: [lat, Validators.required],
      lng: [lng, Validators.required],
      time: [time, Validators.required],

    });
    // @ts-ignore


  }
  initDaysItemRows(sunday= false, monday= false, tuesday= false, wednesday= false, thursday= false, friday= false, saturday= false) {


    return this._fb.group({
      sunday: [sunday, Validators.required],
      monday: [monday, Validators.required],
      tuesday: [tuesday, Validators.required],
      wednesday: [wednesday, Validators.required],
      thursday: [thursday, Validators.required],
      friday: [friday, Validators.required],
      saturday: [saturday, Validators.required],


    });


  }

  async getTravels() {
    this.getBackTravels()
    const result = await getTravelsApi('way=go');
    this.loader=true

    this.editMode = false;
    if (result) {
      this.travels = [];
      this.travels = result.data.data;
      this.data = this._fb.group({
        travel_start_name: ['', Validators.required],
        travel_end_name: ['', Validators.required],
        way: ['', Validators.required],
        way_points: this._fb.array([]),
        work_days: this.initDaysItemRows() ,
      });

    this.loader=false
    }

  }
  async getBackTravels() {
    const result = await getTravelsApi('way=back');
    this.loader=true

    this.editMode = false;
    if (result) {
      this.backTravels = [];
      this.backTravels = result.data.data;
      this.data = this._fb.group({
        travel_start_name: ['', Validators.required],
        travel_end_name: ['', Validators.required],
        way: ['', Validators.required],
        way_points: this._fb.array([]),
        work_days: this.initDaysItemRows() ,
      });

      this.loader=false
    }

  }
  days = {
    sunday: 'الأحد',
    monday: 'الإثنين',
    tuesday: 'الثلاثاء',
    wednesday: 'الأربعاء',
    thursday: 'الخميس',
    friday: 'الجمعة',
    saturday: 'السبت',
  };

  async getTravel(id) {
    const result = await getTravelApi(id);
    this.editMode = true;
    console.log(this.editMode);
    if (result) {

      const bus = result.data.data;
      this.rowSelected = bus;

      const wayPoints = [];
      bus.way_points.map(way => {
        wayPoints.push(this.initItemRows(way.label, Number(way.lat), Number(way.lng), way.time));
      });




      this.data = this._fb.group({
        travel_start_name: [bus.travel_start_name, Validators.required],
        travel_end_name: [bus.travel_end_name, Validators.required],
        way: [bus.way, Validators.required],
        way_points: this._fb.array(wayPoints),
        work_days: this.initDaysItemRows( bus.work_days.includes('sunday'), bus.work_days.includes('monday'), bus.work_days.includes('tuesday'),
          bus.work_days.includes('wednesday'), bus.work_days.includes('thursday'), bus.work_days.includes('friday'), bus.work_days.includes('saturday')
          ) ,
      });

    }

  }

  selectedRow(row) {
    this.rowSelected = {};
    this.rowSelected = row;
    console.log(this.rowSelected)

  }
  changeEditMode() {
    this.editMode = false;
  }

  async removeTravel(id) {
    const result = await removeTravelApi(id);

    if (result) {

      const driver = result.data.data;
      this.getTravels();
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
    }else {
      swal(
        'حصل خطأ، يرجى المحاولة مرة أخرى',
        '',

        'error'
      )
    }


  }
  async edit() {
    const data = this.data.value;


    let days = [];
    let x = [];
    for (const k in data.work_days) {
      if (data.work_days[k]) {
        days.push(k);
      }
    }
    data.way_points.map(point=>{
      x.push({
        label: point.label,
        lat: Number(point.lat),
        lng: Number(point.lng),
        time: point.time,

      })
    })
    data.work_days = days;
    x.sort(function(a, b) {
      // get time time from string
      // then get am or pm from string and append
      // both can be done using slice method
      return Date.parse('1970/01/01 ' + a.time.slice(0, -2) + ' ' + a.time.slice(-2)) - Date.parse('1970/01/01 ' + b.time.slice(0, -2) + ' ' + b.time.slice(-2))
    });
    data.way_points = x;
    const result = await editTravelApi(data, this.rowSelected['_id']);

    if (result) {
      this.getTravels();
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
    }else {
      swal(
        'حصل خطأ، يرجى المحاولة مرة أخرى',
        '',

        'error'
      )
    }


    console.log(this.data.value);
  }
  buses = [];
  async getBuses() {
    const result = await getBusesApi('withDrivers=true');

    if (result) {
      this.buses = [];
      this.buses = result.data.data;



    }

  }
  tripAssignBus = {};

  async getAssignBus(id) {
    this.rowSelected={_id:id}
   const result = await getAssignTirpToBus(id);
   this.tripAssignBus={}
   if(result){
     this.tripAssignBus=result.data.data
     console.log(this.tripAssignBus)

   if(!this.tripAssignBus['bus']){
     this.tripAssignBus['bus']=[]
   }
     this.selectedBus = this.tripAssignBus['bus'];

   console.log(this.tripAssignBus)
   }

  }

  async add() {
    const data = this.data.value;

    const days = [];
    for (const k in data.work_days) {
      if (data.work_days[k]) {
        days.push(k);
      }
    }
    let x=[]
    data.way_points.map(point=>{
      x.push({
        label: point.label,
        lat: Number(point.lat),
        lng: Number(point.lng),
        time: point.time,

      })
    })
    x.sort(function(a, b) {
      // get time time from string
      // then get am or pm from string and append
      // both can be done using slice method
      return Date.parse('1970/01/01 ' + a.time.slice(0, -2) + ' ' + a.time.slice(-2)) - Date.parse('1970/01/01 ' + b.time.slice(0, -2) + ' ' + b.time.slice(-2))
    });
    data.way_points = x;
    data.work_days = days;

    const result = await addTravelApi(data);

    if (result) {
      const details={
        bus:[],
        travel_id:result.data.data._id
      }
      await createTirpDetails(details)
      this.getTravels();
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
    }else {
      swal(
        'حصل خطأ، يرجى المحاولة مرة أخرى',
        '',

        'error'
      )
    }


    console.log(this.data.value);
  }

  selectedBus = [];
  assignToBus(bus, checked) {

    if (this.selectedBus.includes(bus) || checked) {
      this.selectedBus = this.selectedBus.filter(function(value, index, arr) {

        return value != bus;

      });
    } else {
      this.selectedBus.push(bus);
    }

    console.log(this.selectedBus);
  }

  async assignToBusApi() {
    const data = {
      bus: this.selectedBus,
    };
    const result = await assignTirpToBus(this.rowSelected['_id'],data);
    if(result){
      this.getBuses();

      this.getTravels();

      this.selectedBus=[]
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
    }
  }


  changeView() {
    this.tableView = !this.tableView;
  }

  generateMap() {
    // this.map = L.map('map', {
    //   layers: [this.markerLayer, this.polyLineLayer]
    //
    // }).invalidateSize().setView([this.lat, this.lng], 13)

    // L.map('map').invalidateSize()

    // L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    //   attribution: 'Map data &copy; <a href="https://tracllo.com">Tracllo',
    //   maxZoom: 18,
    // }).addTo(this.map);

    // setTimeout(function(){ map.invalidateSize()}, 400);

    //     const layerGroup = L.layerGroup().addTo(this.map);
    //
    // // events are fired when entering or exiting fullscreen.
    //
    //     this.map.addLayer(this.markerLayer);
    //
    //     this.map.addLayer(this.polyLineLayer);

  }

  openMapModal(index) {

    this.pointIndex=index
    const control = <FormArray>this.data.controls['way_points'];
    let lat=control.at(this.pointIndex).get("lat").value;
    let lng=control.at(this.pointIndex).get("lng").value;
    if(lat&&lng){
      this.markers.push({
        lat: lat,
        lng: lng
      });
      this.selectedLocation.lat= lat
      this.selectedLocation.lng=lng
    }

    // this.map.invalidateSize();
    // this.generateMap()

  }
  clickedMarker(label: string, index: number) {
    console.log(`clicked the marker: ${label || index}`)
  }



  markerDragEnd($event: MouseEvent) {
    console.log('dragEnd', $event);
    this.selectedLocation.lat= $event.coords.lat
    this.selectedLocation.lng=$event.coords.lng
  }


  mapClicked($event: MouseEvent) {
    this.markers=[]
    this.markers.push({
      lat: $event.coords.lat,
      lng: $event.coords.lng
    });
    this.selectedLocation.lat= $event.coords.lat
    this.selectedLocation.lng=$event.coords.lng
  }

  markers: marker[] = []
  selectedLocation={
    lat:0,
    lng:0
  }

  addPointLocation() {

    const control = <FormArray>this.data.controls['way_points'];
    control.at(this.pointIndex).get("lat").setValue(this.selectedLocation.lat);
    control.at(this.pointIndex).get("lng").setValue(this.selectedLocation.lng);
    this.selectedLocation={
      lat:0,
      lng:0
    }
    this.markers=[]
  }
  @ViewChild("searchText")
  public searchElementText: ElementRef;

  removeSearch() {
    this.searchElementText.nativeElement.value=""
  }
  print(id){
    var mywindow = window.open('', 'PRINT', 'height=400,width=600');

    mywindow.document.write('<html><head><title>' + document.title  + '</title>');
    mywindow.document.write('<style> table{width:100%} td, th {  border: 1px solid #ddd;padding: 8px;} tr:nth-child(even){background-color: #f2f2f2;} tr:hover {background-color: #ddd;} th {  padding-top: 12px;  padding-bottom: 12px;  text-align: left;background-color: #4CAF50; color: white;}\n' +
      '</style></head><body >');
    mywindow.document.write('<h1>' + document.title  + '</h1>');
    mywindow.document.write(document.getElementById('travel-'+id).innerHTML);
    mywindow.document.write('</body></html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();

    return true;
  }

  buttonClasses(i:number) {
    return {
      'fa fa-map-marker pointer': true,
      'red': this.data.value.way_points[i].lat === 0,
      'green': this.data.value.way_points[i].lat !== 0
    }
  }

}




// just an interface for type safety.

interface marker {
  lat: number;
  lng: number;
  label?: string;
}
